import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { GenericService } from './generic.service';

@Injectable({
	providedIn: 'root',
})
export class CompanyFilesService extends GenericService<any> {
	private http1 = inject(HttpClient);

	constructor() {
		super();
		this.endpoint = 'files';
		this.ACTIONS = {
			list: 'FILES_LIST',
			add: 'FILES_ADD',
			update: 'FILES_UPDATE',
			delete: 'FILES_DELETE',
			item: 'FILES_ITEM',
		};
	}

	getManyCompanyFiles = (companyUuid: any, params: {}) => {
		this.endpoint = `companies/${companyUuid}/files`;
		return super.list(params);
	};

	postManyCompanyFiles = (companyUuid: any, obj: any) => {
		const url = `${this.host}/companies/${companyUuid}/files`;
		const req = new HttpRequest('POST', url, obj, {
			reportProgress: true,
		});
		return this.http1.request(req);
	};

	deleteOneCompanyFile = (companyUuid: any, fileUuid: string) => {
		this.endpoint = `companies/${companyUuid}/files`;
		return super.delete(fileUuid);
	};
}
